import { useState, useEffect } from 'react';

/**
 * Hook to fetch field values from schema
 * 
 * @param {Object} fieldMeta - Field metadata from schema
 * @returns {{values: Array, loading: boolean, error: Error|null}}
 */
export function useFieldValues(fieldMeta) {
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fieldMeta) {
      setValues([]);
      return;
    }

    // If field has static values array
    if (Array.isArray(fieldMeta.values)) {
      setValues(fieldMeta.values);
      setLoading(false);
      return;
    }

    // If field has async values function
    if (fieldMeta.values && typeof fieldMeta.values === 'function') {
      setLoading(true);
      setError(null);
      
      Promise.resolve(fieldMeta.values())
        .then(result => {
          const valueArray = Array.isArray(result) ? result : [];
          setValues(valueArray);
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching field values:', err);
          setError(err);
          setValues([]);
          setLoading(false);
        });
      
      return;
    }

    // No values available
    setValues([]);
    setLoading(false);
  }, [fieldMeta]);

  return { values, loading, error };
}

export default useFieldValues;

